import{mergeWith as e}from"./mergeWith.js";import{noop as m}from"../../function/noop.js";function n(r,...o){return e(r,...o,m)}export{n as merge};
